import {
  useAddReviewThreadComment,
  useReviewThreadAuditTrail,
  useReviewThreadComments,
} from "@/hooks/cle-hooks";
import { showCleApiErrorToast } from "@/lib/showCleApiErrorToast";
import { useToaster } from "rsuite";
import { CleApiErrorText } from "@/components/cle-api/CleApiErrorText";
import Spinner from "@/components/spinner/Spinner";

import { CourseCertificateComments } from "../person/id/Efteruddannelse/CourseCertificateComments";
import { AuditTrailTimeline } from "../person/id/Efteruddannelse/AuditTrailTimeline";

interface DocumentReviewPanelsProps {
  subjectId?: string;
  ownerUserId?: string;
  onCommentAdded?: () => void;
  isReported?: boolean;
}

export const DocumentAuditTrailPanel = ({
  subjectId,
}: DocumentReviewPanelsProps) => {
  const {
    data: auditTrail = [],
    isLoading,
    error,
  } = useReviewThreadAuditTrail(subjectId);

  if (!subjectId) return null;

  return (
    <div className="c-card">
      <h3 className="mb-3">Aktivitetslog</h3>
      {isLoading && <Spinner label="Henter aktivitetslog ..." />}
      {error && (
        <CleApiErrorText
          error={error}
          fallback="Kunne ikke hente aktivitetslog."
          className="text-danger mb-0"
          as="p"
        />
      )}
      {!isLoading && !error && <AuditTrailTimeline events={auditTrail} />}
    </div>
  );
};

export const DocumentCommentsPanel = ({
  subjectId,
  ownerUserId,
  onCommentAdded,
  isReported = false,
}: DocumentReviewPanelsProps) => {
  const {
    data: comments = [],
    isLoading,
    error,
  } = useReviewThreadComments(subjectId);
  const toaster = useToaster();
  const { mutate: addComment, isPending: isAddingComment } =
    useAddReviewThreadComment();

  if (!subjectId) return null;

  return (
    <CourseCertificateComments
      comments={comments}
      error={error}
      isAddingComment={isAddingComment}
      isLoading={isLoading}
      readOnly={isReported}
      onAddComment={(content) =>
        addComment(
          { subjectId, content, userId: ownerUserId },
          {
            onSuccess: () => onCommentAdded?.(),
            onError: (err) => showCleApiErrorToast(toaster, err),
          },
        )
      }
    />
  );
};
